import { BuildDomain } from '../../../src/enums/build/build-domain';

export const buyapowaSessionStorageItem = 'buyapowa';

export const buyapowaLibrarySource = 'https://cdn.co-buying.com/embedding.min.js';

export const localStorageKeyForBuyapowaFriendLandingPage = 'friendLandingPageUrl';

export const enabledBuyapowaDomains: BuildDomain[] = [BuildDomain.DAVID_LLOYD_UK] as const;
export const isDomainEnabledForBuyapowa = (buildDomain: BuildDomain) =>
  enabledBuyapowaDomains.includes(buildDomain);
